import * as angular from 'angular';
import * as moment from 'moment';

import { ComponentDefinition, ExtendedState } from '../../models';
import { DatesHelper } from '../../common/datesHelper';

class ReferenceStateContextualController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    referenceState: ExtendedState;
    states: any[];

    static $inject = [];

    setBeginDate(date: string) {
        if (DatesHelper.isDate(date)) {
            const beginMoment = moment(date);
            this.referenceState.beginDateTime = beginMoment.toISOString();
        }
    }

    setEndDate(date) {
        if (DatesHelper.isDate(date)) {
            const endMoment = moment(date);
            this.referenceState.endDateTime = endMoment.toISOString();
        }
    }

    format(date: Date) {
        return moment(date).format('YYYY-MM-DD HH:mm');
    }
}

export const wtReferenceStateContextual: ComponentDefinition = {
    componentId: 'wtReferenceStateContextual',
    controller: ReferenceStateContextualController,
    template: require('./referenceStateContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        referenceState: '=',
        states: '='
    }
};
